import { French } from "flatpickr/dist/l10n/fr.js"
import { German } from "flatpickr/dist/l10n/de.js"
import { Polish } from "flatpickr/dist/l10n/pl.js"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import { Czech } from "flatpickr/dist/l10n/cs.js"
import { Slovak } from "flatpickr/dist/l10n/sk.js"
import { Ukrainian } from "flatpickr/dist/l10n/uk.js"

export const datepickerLocales = {
  fr: French,
  de: German,
  pl: Polish,
  es: Spanish,
  cz: Czech,
  sk: Slovak,
  ua: Ukrainian,
}
